import React from "react";
import { inject, observer } from "mobx-react";
import ApiCalls from "../../apis/api-calls";
import config from "../../../config/config";
import BillingCustomComponent from "../BillingComponent/BillingCustomComponent";

const convenienceFee = config.convenienceFee;
const BillingForm = inject("sharedStore")(observer(class BillingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentOptions: [],
      paymentId: "",
      checked: false,
      value: "",
      getPaymentType: [],
      screen: 1,
      dropdownError: false,
    };

    this.onPaymentChange = this.onPaymentChange.bind(this);
  }

  componentDidMount() {
    this.setCardsAndBanks();
  }

  newPaymentArr(payArr, type) {
    let paymentArr = [];
    // eslint-disable-next-line array-callback-return
    payArr.map((val) => {
      let obj = {};
      obj["key"] = val.id;
      obj["value"] =
        type === "card"
          ? val.brand.toUpperCase() + " ending in " + val.card_no
          : "Account ending in " + val.bank_no;
      obj["type"] = type;
      obj["id"] = val.payment_id;
      paymentArr.push(obj);
    });
    return paymentArr;
  }

  setCardsAndBanks = () => {
    const cardArr = this.props.sharedStore.paymentArr || [];
    const bankArr = this.props.sharedStore.bankArr || [];
    let newCardArr = [];
    let newBankArr = [];
    if (cardArr.length > 0) {
      newCardArr = this.newPaymentArr(cardArr, "card");
    }
    if (bankArr.length > 0) {
      newBankArr = this.newPaymentArr(bankArr, "bank");
    }
    this.setState({ paymentOptions: newCardArr.concat(newBankArr) });
  };

  renderPaymentOptions() {
    let { paymentOptions } = this.state;
    const options = paymentOptions.map((option, i) => {
      return (
        <option key={option.key} value={option.key}>
          {option.value}
        </option>
      );
    });
    return options;
  }

  handleChargeUpdate = () => {
    const { sharedStore } = this.props;
    const { getPaymentType } = this.state;
    if (getPaymentType && getPaymentType.length > 0) {
      let data = {
        type: getPaymentType[0].type,
        id: getPaymentType[0].id,
      };
      let conversionExist = this.extractHeader(sharedStore.invoicesData);
      this.callPaymentIntent(data, conversionExist);
    }
  };

  callPaymentIntent = (data, conversionExist) => {
    const customerSeriesType = this.props.sharedStore.customerSeriesType;
    const { sharedStore, closeModalHandler } = this.props;
    sharedStore.showLoader();
    return ApiCalls.createCharge(data)
      .then((response) => {
        sharedStore.hideLoader();
        if (response && response.status_code === 200) {
          closeModalHandler();
          this.props.sharedStore.fetchInvoiceList();
          if (data.type === "card") {
            this.props.showPopup(
              4,
              <div>
                <div className="pop-msg success-message">
                  Payment Successful
                </div>
                <br />
                {conversionExist ? (
                  <div className="pop-note">
                    Note: Your customer portal account will be updated and new
                    licensing information will be available shortly. Please
                    refresh the page or log out to see changes reflected.{" "}
                  </div>
                ) : (
                  <div className="pop-note">
                    Note: Licenses May take a moment to update and reflect in
                    the customer portal{" "}
                  </div>
                )}
              </div>
            );
          } else {
            this.props.showPopup(
              4,

              <div>
                <div
                  className={
                    data.type === "bank" ? "pop-msg" : "pop-msg success-message"
                  }
                >
                  {data.type === "bank"
                    ? "Your payment is pending! Please allow up to 5 business days for your payment to be processed"
                    : data.type.message || "ijfhi"}
                </div>
                <br />
                {response.conversion_flag === true ? (
                  <div>
                    <div className="pop-status-imp">Important Note:</div>
                    <div className="pop-msg">
                      Your customer portal account will be updated and licensing
                      information will be available once your payment has moved
                      from pending to successful. You will be notified via email
                      once updates have been made.
                    </div>
                  </div>
                ) : (
                  <div>
                    {customerSeriesType !== 0 ? (
                      data.type === "bank" ? (
                        <div>
                          <div className="pop-status-imp">Important Note:</div>
                          <div className="pop-msg">
                            Your licenses will only be updated at the time of
                            payment if you have all{" "}
                            <span className="color-green"> ONLINE </span>{" "}
                            licenses and sub-licenses{" "}
                          </div>
                          <br />
                          <div className="pop-msg">
                            If you have any{" "}
                            <span className="color-green"> OFFLINE </span>{" "}
                            licenses or sub-licenses, all licenses will be
                            updated once your pending payment has been
                            processed. You will be notified via email once your
                            new token is available.{" "}
                          </div>
                        </div>
                      ) : (
                        <div className="pop-note">
                          Note: Licenses May take a moment to update and reflect
                          in the customer portal{" "}
                        </div>
                      )
                    ) : null}
                  </div>
                )}
              </div>
            );
          }
        } else {
          closeModalHandler();
          this.props.showPopup(2, response.message);
        }
      })
      .catch((err) => {
        sharedStore.hideLoader();
        this.props.showPopup(2, err.message);
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.handleChargeUpdate();
  };

  handleCheckClick = (e, checked = "") => {
    this.setState({ checked: checked === "" ? !this.state.checked : false });
  };

  navigateToPaymentProfile = () => {
    this.props.closeModalHandler();
    this.props.handleActiveTab("billing");
  };

  onPaymentChange = (event) => {
    this.dropdownError(false);
    document.getElementById("payDrop").style.color = "rgb(51, 51, 51)";
    var getPaymentType = this.state.paymentOptions.filter((opt) => {
      return opt.key === Number(event.target.value);
    });
    this.setState({
      paymentId: event.target.value,
      getPaymentType: getPaymentType,
    });
  };

  dropdownError = (flag) => {
    this.setState({
      dropdownError: flag,
    });
  };

  setFirstScreenCheckbox = () => {
    this.setState({
      checked: false,
    });
  };

  customAmount = (e) => {
    this.props.setScreen(e, 2);
    this.setState({
      checked: false,
    });
  };

  extractHeader = (invoicesData) => {
    let header =
      invoicesData &&
      invoicesData
        .filter((val) => val.is_paid === 0 || val.is_paid === 3)
        .map((val) => {
          return val.header;
        });
    return (
      header.includes("Conversion") ||
      header.includes("Conversion Series 6 to 7")
    );
  };

  render() {
    const { isCustomPayment,payableAmount } = this.props.sharedStore;
    const { screen } = this.props;

    let { getPaymentType } = this.state;
    let conFee =
      getPaymentType.length > 0 && getPaymentType[0].type === "bank"
        ? 0
        : ((payableAmount * convenienceFee) / 100).toFixed(2);
    let totalAmount = Number(payableAmount) + Number(conFee);
    return (
      <form>
        <div className="field-wrapper payModel">
          <div
            className="form-group"
            
          >
            <label
              htmlFor="fName"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#333333",
              }}
            >
              Select Payment Method
            </label>
            <select
              disabled={screen === 3 ? true : false}
              type="label"
              maxLength="100"
              autoComplete="off"
              name="payment-methods"
              className={
                this.state.dropdownError
                  ? "form-control card-control error"
                  : screen === 3
                  ? "form-control card-control greyout"
                  : "form-control card-control"
              }
              id="payDrop"
              onChange={this.onPaymentChange}
              value={this.state.paymentId}
            >
              <option value="" disabled defaultValue>
                ---Choose---
              </option>
              {this.renderPaymentOptions()}
            </select>
            {this.state.dropdownError ? (
              <div className="error_msg">Payment method cannot be empty</div>
            ) : null}
          </div>
          {screen === 3 ? null : (
            <div
              className="payDetails-1"
              onClick={this.navigateToPaymentProfile}
            >
              + Add Payment Method
            </div>
          )}
          {screen === 1 ? (
            <div>
              <div className="payDetails-2">Invoice Details</div>
              <div className="payDetails-3">
                Note: Total balance includes any applicable credits
              </div>
              <div
                className={
                  getPaymentType.length > 0 && getPaymentType[0].type !== "card"
                    ? "hidePay"
                    : "payDetails-4"
                }
              >
                <div>Total Balance</div>
                <div>
                  $
                  {payableAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}
                </div>
              </div>
              <div
                className={
                  getPaymentType.length > 0 && getPaymentType[0].type !== "card"
                    ? "hidePay"
                    : "payDetails-7"
                }
              >
                <div>Convenience Fee</div>
                <div>
                  $
                  {conFee.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}
                </div>
              </div>
              <div className="payDetails-10">
                <div>Total Due:</div>
                <div>
                  $
                  {totalAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}
                </div>
              </div>
            </div>
          ) : null}
          {screen === 2 || screen === 3 ? (
            <BillingCustomComponent
              callPaymentIntent={this.callPaymentIntent}
              handleBankPayment={this.handleChargeUpdate}
              paymentType={this.state.getPaymentType}
              paymentId={this.state.paymentId}
              screen={screen}
              extractHeader={this.extractHeader}
              dropdownError={this.dropdownError}
              setScreen={this.props.setScreen}
            />
          ) : (
            ""
          )}
        </div>
        {screen === 1 ? (
          <div className="payDetails-10 adjust-text">
            <input
              type="checkbox"
              className="billing-check"
              checked={this.state.checked}
              onChange={this.handleCheckClick}
            />
            I authorize Izenda to electronically debit my account and, if
            necessary, electronically credit my account to correct erroneous
            debits.
          </div>
        ) : null}
        {screen === 1 ? (
          <div className="text-center consent" id="payDetails-13">
            <button
              disabled={!this.state.checked || !this.state.paymentId}
              className="btn btn-common"
              onClick={this.handleSubmit}
            >
              Submit Payment
            </button>
          </div>
        ) : null}

        {screen === 1 && isCustomPayment ? (
          <div
            style={{
              "textAlign": "center",
              "marginTop": "6px",
              "fontSize": "12px",
            }}
          >
            <span className="pay_cusamt" onClick={(e) => this.customAmount(e)}>
              Pay Custom Amount
            </span>
          </div>
        ) : null}
      </form>
    );
  }
}));

export default BillingForm 



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/BIllingForm.jsx